import {
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  LinearScale,
  PointElement,
  ScriptableChartContext,
  Title,
  Tooltip,
} from "chart.js";
import { Chart } from "react-chartjs-2";

import { prepareOverviewChartData } from "./helpers";

import { useTransferReport } from "@/api/queries/reports";

ChartJS.register(CategoryScale, LinearScale, BarElement, BarController, PointElement, Title, Tooltip);

type OverviewChartProps = {
  destinationID?: string;
};
const OverviewChart = ({ destinationID }: OverviewChartProps) => {
  const { data: transferReport } = useTransferReport(destinationID);

  const { labels, data } = prepareOverviewChartData(transferReport);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Rows Transferred",
        data: data,
        barPercentage: 0.9,
        backgroundColor: (context: ScriptableChartContext) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) {
            return;
          }
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, "#10b981");
          gradient.addColorStop(1, "#10b981");
          return gradient;
        },
        borderWidth: 0,
        borderRadius: 2,
      },
    ],
  };

  const options: ChartOptions = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true,
      },
    },

    interaction: {
      intersect: false,
      mode: "index",
    },

    scales: {
      x: {
        title: {
          display: false,
          text: "Day",
        },
        grid: {
          display: false,
          // @ts-expect-error Ignore error about drawBorder not existing
          drawBorder: true,
        },
      },
      y: {
        title: {
          display: true,
          text: "Rows transferred",
        },
        min: 0,
        suggestedMax: 1000,

        ticks: {},
        grid: {
          display: true,
          // @ts-expect-error Ignore error about drawBorder not existing
          drawBorder: false,
        },
      },
    },
  };

  return (
    <div className="mx-auto max-w-7xl px-2 pb-8">
      <Chart data={chartData} type="bar" height={60} options={options} />
    </div>
  );
};

export default OverviewChart;
